import { mainSiteUrl } from '@/mocks/categories';

export default function CtaSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1000px] mx-auto text-center">
        <div className="relative rounded-2xl overflow-hidden h-64 md:h-80 mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20laptop%20displaying%20colorful%20spreadsheet%20charts%20and%20graphs%20next%20to%20stylish%20products%20warm%20coffee%20tones%20morning%20sunlight%20through%20blinds%20creating%20stripe%20shadows%20productivity%20aesthetic%20professional%20editorial%20quality&width=1400&height=700&seq=cta-v2-spreadsheet&orientation=landscape"
            alt="PandabuySpreadsheet product collection overview"
            className="w-full h-full object-cover object-top"
            title="PandabuySpreadsheet - Complete Product Database"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
        </div>

        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-5 leading-tight max-w-[700px] mx-auto">
          Start Using{' '}
          <span className="italic font-normal text-foreground-500">pandabuyspreadsheet</span>
          {' '}Today
        </h2>

        <p className="text-foreground-600 text-sm md:text-base max-w-[550px] mx-auto mb-10 leading-relaxed">
          Join thousands of smart shoppers who use structured spreadsheets to make better buying decisions every day.
        </p>

        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-database-2-line"></i>
          <span>View Full Spreadsheet Database</span>
        </a>
      </div>
    </section>
  );
}